import { MapContainer, TileLayer, Marker, Circle } from "react-leaflet";

export default function SiteLiveMap({ site, userPos, size = 320, zoom = 15 }) {
  if (!site?.lat || !site?.lng) return null;

  const siteCenter = [site.lat, site.lng];
  const radius = Number(site.radiusMeters ?? 100);

  const userCenter =
    userPos?.lat && userPos?.lng ? [userPos.lat, userPos.lng] : null;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: 12,
        overflow: "hidden",
        border: "1px solid #e5e7eb",
        margin: "0 auto"
      }}
    >
      <MapContainer
        center={siteCenter}
        zoom={zoom}
        style={{ width: "100%", height: "100%" }}
      >
        <TileLayer
          attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={siteCenter} />
        <Circle center={siteCenter} radius={radius} />
        {userCenter && <Marker position={userCenter} />}
      </MapContainer>
    </div>
  );
}